/*
 * This file contains a skeleton loader for the floorplan card component.
 */

import clsx from "clsx";
import styles from "../../floorplans.module.scss";
import skeltonStyle from "./floorplansSkelton.module.scss";


export default function FloorplanCardSkelton({ activeTab, typeListing = true }) {
  if (activeTab === "grid")
    return (
      <div className={clsx(styles.FloorplanGridCard)}>
        <div className={clsx(styles.Availability, skeltonStyle.skeleton)}></div>
        <div className={clsx(styles.FpImage, skeltonStyle.FpImage)}>
          <div
            className={clsx(skeltonStyle.skeleton, skeltonStyle.imageFrame)}
          ></div>
        </div>
        <div className={styles.CardFooter}>
          <ul className={clsx(styles.Features, skeltonStyle.Features)}>
            <li
              className={clsx(skeltonStyle.skeleton, skeltonStyle.featureItem)}
            ></li>
            <li
              className={clsx(skeltonStyle.skeleton, skeltonStyle.featureItem)}
            ></li>
          </ul>
          <h3
            className={clsx(
              styles.Name,
              skeltonStyle.skeleton,
              skeltonStyle?.Name
            )}
          ></h3>
          <p className={styles.PriceSpace}>
            $
            <span
              className={clsx(skeltonStyle.skeleton, skeltonStyle?.priceSpace)}
            ></span>
            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="3" cy="3" r="2" stroke="#AD8E6F"></circle></svg>
            <span
              className={clsx(skeltonStyle.skeleton, skeltonStyle?.priceSpace)}
            ></span>{" "}
            SQ.FT.
          </p>
        </div>
        <div className={clsx(styles.BtnWrapper, skeltonStyle.BtnWrapper, "skeleton-card-btn-wrapper")}>
          <a
            href={"#"}
            className={clsx(styles.Btn, styles.primary, skeltonStyle.skeleton)}
          ></a>
          <a
            href={"#"}
            className={clsx(
              styles.Btn,
              styles.secondary,
              skeltonStyle.skeleton
            )}
          ></a>
        </div>
      </div>
    );
  else if (activeTab === "list")
    return (
      <div className={styles.FloorplanListCard}>
        <h3
          className={clsx(
            styles.Name,
            skeltonStyle.skeleton,
            skeltonStyle?.Name
          )}
        ></h3>
        {/* Show bed/bath chips for floorplan listing, floor for unit listing */}
        {typeListing ? (
          <ul className={styles.Features}>
            <li
              className={clsx(skeltonStyle.skeleton, skeltonStyle.featureItem)}
            ></li>
            <li
              className={clsx(skeltonStyle.skeleton, skeltonStyle.featureItem)}
            ></li>
          </ul>
        ) : (
          <div className={clsx(styles.TwoLineBox, skeltonStyle.TwoLineBox)}>
            Floor
            <span className={skeltonStyle.skeleton}></span>
          </div>
        )}
        <div className={clsx(styles.TwoLineBox, skeltonStyle.TwoLineBox)}>
          Available
          <span className={skeltonStyle.skeleton}></span>
        </div>
        <div className={clsx(styles.TwoLineBox, skeltonStyle.TwoLineBox)}>
          Price
          <span className={skeltonStyle.skeleton}></span>
        </div>
        <div className={clsx(styles.TwoLineBox, skeltonStyle.TwoLineBox)}>
          Square Footage <span className={skeltonStyle.skeleton}></span>
        </div>
        <div className={clsx(styles.BtnWrapper, skeltonStyle.BtnWrapper, !typeListing && styles.unitBtnWrapper)}>
          <a
            href={"#"}
            className={clsx(styles.Btn, styles.primary, skeltonStyle.skeleton)}
          ></a>
          <a
            href={"#"}
            className={clsx(
              styles.Btn,
              styles.secondary,
              skeltonStyle.skeleton
            )}
          ></a>
        </div>
      </div>
    );
}
